import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import SvgSortAscending from '../../asset/svg/SortAscending';
import SvgSortDescending from '../../asset/svg/SortDescending';

const styles = (theme) => {
    return {
        label: {
            display: 'inline-block',
            position: 'relative',
            top: 1,
            bottom: 0,
            left: 0,
            marginRight: 6,
            height: 28,
            lineHeight: '28px',
            fontSize: 12,
            fontVariant: 'small-caps',
            textTransform: 'uppercase',
            verticalAlign: 'middle',
            color: theme.palette.text.secondary,
        },
        icon: {
            display: 'inline-block',
            position: 'relative',
            verticalAlign: 'middle',
            width: 20,
            height: 20,
            cursor: 'pointer',
            color: theme.palette.text.secondary,
        }
    }
}

class Sort extends Component {
    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.props.value !== nextProps.value);
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div className={this.props.className}>
                <Typography
                    className={classes.label}
                    align='left'
                >
                    {this.props.label}
                </Typography>
                {this._renderIcon()}
            </div>
        );
    }

    _renderIcon = () => {
        const {classes} = this.props;

        if (this.props.value === 'descending') {
            return (
                <SvgSortDescending
                    className={classes.icon}
                    onClick={this._handleToggleAscending}
                />
            )
        } else if (this.props.value === 'ascending') {
            return (
                <SvgSortAscending
                    className={classes.icon}
                    onClick={this._handleToggleDescending}
                />
            )
        }

        return null;
    }

    _handleToggleAscending = () => {
        if (this.props.onClick) {
            this.props.onClick('ascending');
        }
    }

    _handleToggleDescending = () => {
        if (this.props.onClick) {
            this.props.onClick('descending');
        }
    }
}

Sort.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func,
}

export default withStyles(styles)(Sort);
